/* =============================================================================
   solvelt-listing-card.js
   Drop into: assets/solvelt-listing-card.js
   Load via:  {{ 'solvelt-listing-card.js' | asset_url | script_tag }}
   ============================================================================= */

(function () {
  'use strict';

  /* ── HOURS TOGGLE ────────────────────────────────────────────────────────── */
  function initHoursToggles() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.slv-ht-row');
      if (!btn) return;
      var body = btn.nextElementSibling;
      var icon = btn.querySelector('.slv-ht-tog');
      if (!body) return;
      var isOpen = body.classList.contains('open');
      body.removeAttribute('hidden');
      body.classList.toggle('open', !isOpen);
      if (icon) icon.classList.toggle('open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  /* ── READ MORE / LESS ────────────────────────────────────────────────────── */
  function initReadMore() {
    document.querySelectorAll('.slv-rm').forEach(function (btn) {
      var targetId = btn.getAttribute('aria-controls');
      var target   = document.getElementById(targetId);
      var shortText = target ? target.textContent : '';
      var fullText  = btn.getAttribute('data-full') || shortText;

      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        if (target) {
          target.textContent = expanded ? (shortText.length > 140 ? shortText.slice(0, 140) + '…' : shortText) : fullText;
        }
        btn.setAttribute('aria-expanded', String(!expanded));
        btn.textContent = expanded ? 'Read more ↓' : 'Read less ↑';
      });
    });
  }

  /* ── WISHLIST ────────────────────────────────────────────────────────────── */
  function initWishlist() {
    // Load saved state from localStorage
    var saved = JSON.parse(localStorage.getItem('slv_wishlist') || '[]');

    document.querySelectorAll('.slv-wh').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      if (saved.indexOf(id) > -1) {
        btn.classList.add('saved');
        btn.textContent = '♥';
      }

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isSaved = btn.classList.toggle('saved');
        btn.textContent = isSaved ? '♥' : '♡';
        btn.setAttribute('aria-label', isSaved ? 'Remove from wishlist' : 'Save to wishlist');

        // Persist
        var list = JSON.parse(localStorage.getItem('slv_wishlist') || '[]');
        if (isSaved) {
          if (list.indexOf(id) === -1) list.push(id);
        } else {
          list = list.filter(function (x) { return x !== id; });
        }
        localStorage.setItem('slv_wishlist', JSON.stringify(list));
      });
    });
  }

  /* ── ADD TO CART ─────────────────────────────────────────────────────────── */
  function initAddToCart() {
    document.querySelectorAll('.slv-btn-cart').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        var originalText = btn.textContent;
        btn.textContent = 'Adding…';
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            btn.textContent = '✓ Added';
            // Refresh cart count if theme uses a bubble
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 2000);
          })
          .catch(function () {
            btn.textContent = 'Error — try again';
            setTimeout(function () {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 2000);
          });
      });
    });
  }

  /* ── FILTER PILLS (collection page toolbar) ──────────────────────────────── */
  function initFilters() {
    var pills = document.querySelectorAll('.slv-filter-pill[data-filter]');
    if (!pills.length) return;

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('active'); });
        pill.classList.add('active');
        applyFilter(pill.getAttribute('data-filter'));
      });
    });
  }

  function applyFilter(filter) {
    document.querySelectorAll('.slv-card').forEach(function (card) {
      var status = card.getAttribute('data-status');
      var kosher = card.getAttribute('data-kosher') === 'true';
      var visible = true;

      if (filter === 'online'  && status !== 'online') visible = false;
      if (filter === 'kosher'  && !kosher)             visible = false;

      card.style.display = visible ? '' : 'none';
    });
  }

  /* ── SERVICE ACTION BUTTONS ──────────────────────────────────────────────── */
  /*
     These are UI-only for now. Wire them up once the Seller Portal
     endpoints are ready:
       schedule → /apps/solvelt/schedule?product_id=...
       chat     → /apps/solvelt/chat?product_id=...
       sms      → /apps/solvelt/sms?product_id=...

     Pricing tier gating:
       Add data-tier-locked attribute to any button to disable it.
       Example Liquid: {% if seller_tier != 'pro' %}data-tier-locked{% endif %}
  */
  function initServiceActions() {
    document.querySelectorAll('[data-action]').forEach(function (btn) {
      if (btn.hasAttribute('data-tier-locked')) return;

      btn.addEventListener('click', function () {
        var action    = btn.getAttribute('data-action');
        var productId = btn.getAttribute('data-product-id');

        // Placeholder — replace with real routing once Seller Portal is live
        console.log('[Solvelt] Action:', action, '| Product:', productId);

        /* Future:
        if (action === 'schedule') window.location = '/apps/solvelt/schedule?id=' + productId;
        if (action === 'chat')     openChatWidget(productId);
        if (action === 'sms')      openSmsWidget(productId);
        */
      });
    });
  }

  /* ── MEDIA BUTTONS ───────────────────────────────────────────────────────── */
  /*
     Placeholder. Wire up once you have an audio player / video modal.
     data-media-type = "audio" | "video"
     data-media-url  = the asset URL
  */
  function initMediaButtons() {
    document.querySelectorAll('.slv-mb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var type = btn.getAttribute('data-media-type');
        var url  = btn.getAttribute('data-media-url');
        console.log('[Solvelt] Media:', type, url);
        // TODO: open lightbox / audio player modal
      });
    });
  }


  /* ── BOOT ────────────────────────────────────────────────────────────────── */
  function init() {
    initHoursToggles();
    initReadMore();
    initWishlist();
    initAddToCart();
    initFilters();
    initServiceActions();
    initMediaButtons();
    
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }


})();
